import React from 'react';
import { Nullable } from 'global';
import { formatCurrency } from 'utils';
import { Control, useWatch } from 'react-hook-form';
import { Chip, Stack, Typography, ChipProps } from '@mui/material';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { DealBuilderFormValues } from '../../../../types';

interface Props {
  rowIndex: number;
  control: Control<DealBuilderFormValues>;
}

const getAllowanceStatus = (value: number): Nullable<{ label: string; color: ChipProps['color'] }> => {
  if (value > 0) return { label: 'Over-Allowance', color: 'warning' };
  if (value < 0) return { label: 'Under-Allowance', color: 'info' };

  return null;
};

export const OverOrUnderAllowanceCell = ({ control, rowIndex }: Props) => {
  const [overUnderAllowance] = useWatch({
    control,
    name: [`pricing.tradeIn.${rowIndex}.overUnderAllowance`],
  });

  const allowance = typeof overUnderAllowance === 'number' ? overUnderAllowance : 0;
  const status = getAllowanceStatus(allowance);

  return (
    <Stack gap="0.25rem" alignItems="flex-end" width="100%">
      <Typography align="right">{formatCurrency(Math.abs(allowance), true)}</Typography>

      <RenderWithCondition condition={!!status}>
        <Chip size="small" color={status?.color} label={<Typography variant="caption">{status?.label}</Typography>} />
      </RenderWithCondition>
    </Stack>
  );
};
